// IMPORT PACKAGE REFERENCES

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// IMPORT PROJECT REFERENCES

import DeviceListItem from './DeviceListItem';
import { DeviceFilter } from './DeviceFilter';
import { DeviceSidebar } from './DeviceSidebar';


// COMPONENT

const renderList = devices => (
    devices.map(device => renderListItem(device))
);

const renderListItem = device => (
    <DeviceListItem key={device.LatestSetupPharmacyId} device={device} />
);

const DeviceList = (props) => (
    <div className="container filled">
        <div className="row">
            <div className="col-3">
                <DeviceSidebar />
            </div>
            <div className="device-column-header col-9">
                <div className="row">
                    <div className="col-2">
                        <a className="column-header">Device ID</a>
                    </div>
                    <div className="col-3">
                        <a className="column-header">Pharmacy</a>
                    </div>
                    <div className="col-1">
                        <a className="column-header">Battery</a>
                    </div>
                    <div className="col-1">
                        <a className="column-header">Network</a>
                    </div>
                    <div className="col-1">
                        <a className="column-header">Power</a>
                    </div>
                    <div className="col-2">
                        <a className="column-header">Created</a>
                    </div>
                    <div className="col-2">
                        <a className="column-header">Last Active</a>
                    </div>
                    <div className="col-2">
                        <a className="column-header">Last Report</a>
                    </div>
                    <div className="col-2">
                        <a className="column-header">Last Touched</a>
                    </div>
                </div>
                { props.devices.length === 0 && <div class="empty-placeholder">No devices</div>}
                {renderList(props.devices)}
            </div>
        </div>
    </div>
);

DeviceList.propTypes = {
    devices: PropTypes.array.isRequired
};

export { DeviceList };